import { render, staticRenderFns } from "./AddCommit.vue?vue&type=template&id=29bdfbec&scoped=true"
import script from "./AddCommit.vue?vue&type=script&lang=js"
export * from "./AddCommit.vue?vue&type=script&lang=js"
import style0 from "./AddCommit.vue?vue&type=style&index=0&id=29bdfbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bdfbec",
  null
  
)

export default component.exports